import React, { useEffect, useState } from "react";
import API from "../../services/adminApi";
import ProgramModal from "./ProgramModal";
import "../../../styles/admin.css";

function ProgramList() {
  const [programs, setPrograms] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchPrograms = async () => {
    try {
      setLoading(true);
      const res = await API.get("programs/");
      setPrograms(res?.data || []);
    } catch (err) {
      console.error("Program fetch error:", err);
      setError("Failed to load programs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrograms();
  }, []);

  const deleteProgram = async (id) => {
    if (!window.confirm("Are you sure you want to delete this program?")) return;

    try {
      await API.delete(`programs/${id}/`);
      fetchPrograms();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete program.");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditData(null);
    fetchPrograms();
  };

  return (
    <div className="page-content">

      <div className="list-header">
        <h2>Programs Management</h2>
        <button
          className="btn-primary"
          onClick={() => {
            setEditData(null);
            setShowModal(true);
          }}
        >
          + Add Program
        </button>
      </div>

      {loading && <div className="admin-loading">Loading programs...</div>}
      {error && <div className="admin-error">{error}</div>}

      {!loading && programs.length === 0 && (
        <div className="empty-state">No programs found.</div>
      )}

      {!loading && programs.length > 0 && (
        <div className="table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Description</th>
                <th style={{ width: "160px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {programs.map((p) => (
                <tr key={p.id}>
                  <td>{p.title}</td>
                  <td>{p.description}</td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => {
                        setEditData(p);
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </button>

                    <button
                      className="btn-delete"
                      onClick={() => deleteProgram(p.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <ProgramModal
          editData={editData}
          close={closeModal}
        />
      )}
    </div>
  );
}

export default ProgramList;